import { Entry } from '../Entry'

export function Entry20240827() {
  return (
    <Entry title="27/08/2024 - v3.8.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15958/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
